import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatDistanceToNow } from 'date-fns';

// Firebase
import { db } from '../../../../config/firebase-config';
import { collection, getDocs, getDoc, doc, query, where } from 'firebase/firestore';

// Redux
import { connect } from 'react-redux';

// Libraries - imported
import moment from 'moment';

// Actions
import { addLike } from '../../../../actions/chatActions';

// components - imported
import { Avatar, Button } from '@material-ui/core';
import ImageBlock from '../../../common/ImageBlock';
import DefaultAvatar from 'react-avatar';
import Verification_Badge from '../../../common/Verification_Badge';
import Spinner from '../../../common/Spinner';

// DraftJS
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";

const Post_Message = ({ 
    message: { 
        _id, 
        user, 
        text, 
        date,
        likes,
        postId
    },
    chat: {
        chat
    },
    auth,
    chatData,
    otherChatUserId,
    addLike,
    scrollToBottom
}) => {

    // --- Convert DraftJS text to HTML text

    // Tracks whether the text has been converted
    const [gotText, setGotText] = useState(false);
    // Stores the converted text
    const [textState, setTextState] = useState(null);

    // --- END: Convert DraftJS text to HTML text

    // --- Get Media data ---

    // Check if post has image - for font size reasons
    const [hasImg, setHasImg] = useState(false);
    // Flag for checking if hasImg is properly updated
    const [checkHasImg, setCheckHasImg] = useState(false);

    // --- END: Get Media data ---

    // --- Get Post data ---

    const [postData, setPostData] = useState(null);
    const [gotPost, setGotPost] = useState(false);

    // --- END: Get Post data ---

    // --- Read receipt stuff ---

    const [lastMessageID, setLastMessageID] = useState(null);
    const [lastMessage, setLastMessage] = useState(null);
    const [notRead, setNotRead] = useState(true);

    // --- END: Read receipt stuff ---

    // --- Message Btns stuff ---

    // Tracks the like status of post
    const [liked, setLiked] = useState(false);
    // Flag for checking if like is properly updated
    const [checkLike, setCheckLike] = useState(false);

    // --- END: Message Btns stuff ---

    useEffect(() => {
        //( Get Post Data
        if(postId) getPostData(postId);

    }, [])

    useEffect(() => {
        
        // Scroll to the bottom of messages when a new post is loaded
        scrollToBottom();

    }, [postData])

    // Handle Read Reciept
    useEffect(() => {
    
            if(chat) {
                if(chat.last_message_id) setLastMessageID(chat.last_message_id)
                setLastMessage(chat.last_message);
    
                setNotRead(true);
    
                if(Array.isArray(chat.read)) {
                    if(!chat.read.includes(otherChatUserId)) {
                        setNotRead(false);
                    }
                } else {
                    if(Array.isArray(chatData?.read) && !chatData?.read.includes(otherChatUserId)) {
                        setNotRead(false);
                    }
                }
            }
    
            
    
        }, [chat])

    // --- Message Btn Actions ----

    // Handle message like action
    const handleLike = (_id) => {
        if(auth.user && _id && chat._id) {
            addLike(_id, auth.user, likes, chat._id, otherChatUserId);

            // Toggles the like status
            setLiked(!liked);
        }
    }

    // Checks if the user has already liked the message
    if(auth.user && !checkLike) {
        if(likes?.length > 0){
            setLiked(true);
        }
        
        // Marks that the check for likes has been performed
        setCheckLike(true);
    }  

    // --- END: Message Btn Actions ---

    // --- Sent By Current User ---

    // Initial state set-up for checking if the message is sent by the current user
    let isSentByCurrentUser = false;

    // Set 'true' if the user_name matches the current user's name
    if(user === auth.user._id) {
        isSentByCurrentUser = true;
    }

    // --- END: Sent By Current User ---

    // Get Post Data
    const getPostData = async (id) => {
        // Create a reference to the specified post document in the "posts" collection
        const docRef = doc(db, 'posts', id)
        
        // Retrieve the document with the specified ID from the "posts" collection
        const postDoc = await getDoc(docRef);

        console.log('GOT POST BY ID');
    
        if(postDoc.data()) {
            setPostData({
                ...postDoc.data(),
                _id: id
            })
        } else {
            setPostData(null);
        }

        setGotPost(true);
    }


    // Converts the DraftJS text to HTML and sets the converted text
    if (postData && !gotText) {

        let unRawState;

        if(postData.text !== null) {
            unRawState = EditorState.createWithContent(
                convertFromRaw(JSON.parse(postData.text))
            );
            
            const unRawDescription = draftToHtml(convertToRaw(unRawState.getCurrentContent()));

            setTextState(unRawDescription);
        }

        // Marks that the text conversion has been performed
        setGotText(true)
    }

    let optimized_profile_img_path;

    if(postData?.user.img) {

        // --- ImageKit (img optimization service) ---
   
        // Replace the firebase URL with ImageKit.io URL-endpoint
        optimized_profile_img_path = postData.user.img.replace("https://firebasestorage.googleapis.com","https://ik.imagekit.io/pba3w2st28/");
    }

    // Read status comparison
    let showReadReceipt = false;

    if(lastMessageID) {
        if(lastMessageID === _id) {
            showReadReceipt = true
        }
    } else if(lastMessage === text) {
        showReadReceipt = true;
    }

    let content = <Spinner />;

    if (gotPost) {
        content = (
            <Fragment>
                <div style={{display: 'flex', alignItems: 'center', paddingBottom: '8px'}}>
                    <div className="post__avatar in_chatBox" onClick={() => window.location.href = `/${postData.user.username}`}>
                        {postData.user.img ? (
                            <Avatar src={optimized_profile_img_path && optimized_profile_img_path} />
                        ) : (
                            <DefaultAvatar name={`${postData.user.first_name} ${postData.user.last_name}`} />
                        )}
                    </div>
                    <div style={{lineHeight: '15px'}}>
                        <p style={{color: 'rgb(15, 20, 25)', marginLeft: '5px', fontSize: '15px'}}>{postData.username && postData.username + ' '}</p>
                        {/* Post Timestamp */}
                        <span style={{margin: '0 3px 0 5px'}} className="post__headerSpecial">
                            {formatDistanceToNow(postData.date)} ago
                        </span>
                    </div>
                </div>
                {textState !== null && (

                    <div className='post_message_text' dangerouslySetInnerHTML={{__html: textState}} />
                )}
                <div style={{position: 'relative'}}>
                    {/* Post Images */}
                    <ImageBlock detailPost={postData} setHasImg={setHasImg} setCheckHasImg={setCheckHasImg} checkHasImg={checkHasImg} redirect_on_click in_chatBox />
                </div>
            </Fragment>
        )
    }
    
    return (
        <div onClick={postData ? () => window.location.href = `/post/${postData._id}` : null} style={{cursor: 'pointer'}} className={`messageContainer ${isSentByCurrentUser ? 'currentUser' : ''}`}>

            <div className="messageBox__container in_chatBox">
                {/* Msg*/}
                <div style={{background: 'rgb(239,239,239)'}} className="messageBox">
                    {content}
                </div>

                {/* Msg timestamp */}
                <div className="messageBox__specialText">
                    <p>{moment(date).format('dddd')}{' '}{moment(date).format("h:mm a")}</p>

                    {showReadReceipt && (
                        (notRead) ? (
                            <p style={{marginLeft: '5px'}}>&#8226; <span style={{fontWeight:700}}>Delivered</span></p>
                        ) : (
                            <p style={{marginLeft: '5px'}}>&#8226; <span style={{fontWeight:700}}>Seen</span></p>
                        )
                    )}
                </div>
            </div>
        </div>
    )
}

Post_Message.propTypes = {
    chat: PropTypes.object.isRequired, // Required prop: Function to get user by ID
    addLike: PropTypes.func.isRequired, // Required prop: Function to add a like
    auth: PropTypes.object.isRequired, // Required prop: Object representing the authenticated user
}

const mapStateToProps = state => ({
    // Mapping the auth state from the Redux store to the 'auth' prop
    auth: state.auth,
    chat: state.chat,
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    addLike, 
})(Post_Message);